import { render, staticRenderFns } from "./PCorporationInformation.vue?vue&type=template&id=22a6a3d5&"
import script from "./PCorporationInformation.vue?vue&type=script&lang=ts&"
export * from "./PCorporationInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports